import get from 'lodash/get';

import { call } from '../xmAPI';

const URI = '/webapi/xm/1/event-suppressions';

export const LOAD = 'eventSuppressions/LOAD';
export const LOAD_START = `${LOAD}_START`;
export const LOAD_SUCCESS = `${LOAD}_SUCCESS`;
export const LOAD_FAIL = `${LOAD}_FAIL`;

const defaultParams = {
  offset: 0,
  limit: 100,
  event: '',
  embed: 'match.event',
};

export function load(params) {
  return {
    type: LOAD,
    meta: {
      xmApi: true,
      method: 'get',
      uri: URI,
      params: {
        ...defaultParams,
        ...params,
      },
    },
    payload: {
      eventId: params.eventId,
      sortBy: params.sortBy,
      sortOrder: params.sortOrder,
    },
  };
}

export const LOAD_MORE = 'eventSuppressions/LOAD_MORE';
export const LOAD_MORE_START = `${LOAD_MORE}_START`;
export const LOAD_MORE_SUCCESS = `${LOAD_MORE}_SUCCESS`;
export const LOAD_MORE_FAIL = `${LOAD_MORE}_FAIL`;

export const loadMore = ({ eventId, uri }) => ({
  type: LOAD_MORE,
  payload: {
    eventId,
  },
  meta: {
    xmApi: true,
    method: 'get',
    uri,
  },
});

export const GET_TIME_RANGE = 'eventSuppressions/GET_TIME_RANGE';
export const GET_TIME_RANGE_START = `${GET_TIME_RANGE}_START`;
export const GET_TIME_RANGE_SUCCESS = `${GET_TIME_RANGE}_SUCCESS`;
export const GET_TIME_RANGE_FAIL = `${GET_TIME_RANGE}_FAIL`;

export const getTimeRange = eventId => dispatch => {
  dispatch({
    type: GET_TIME_RANGE_START,
    payload: { eventId },
  });

  const uri = `${URI}?event=${eventId}&offset=0&limit=1&sortBy=START_TIME&embed=match.event`;
  return Promise.all([
    call(`${uri}&sortOrder=ASCENDING`),
    call(`${uri}&sortOrder=DESCENDING`),
  ])
    .then(([start, end]) => {
      dispatch({
        type: GET_TIME_RANGE_SUCCESS,
        payload: {
          eventId,
          start: get(start, 'data[0].match.created', ''),
          end: get(end, 'data[0].match.created', ''),
        },
      });
    })
    .catch(err => {
      dispatch({
        type: GET_TIME_RANGE_FAIL,
        payload: {
          eventId,
          err,
        },
      });
    });
};

export const GET_FILTER_DETAILS = 'eventSuppressions/GET_FILTER_DETAILS';
export const GET_FILTER_DETAILS_START = `${GET_FILTER_DETAILS}_START`;
export const GET_FILTER_DETAILS_SUCCESS = `${GET_FILTER_DETAILS}_SUCCESS`;
export const GET_FILTER_DETAILS_FAIL = `${GET_FILTER_DETAILS}_FAIL`;

export const getFilterDetails = filterIds => dispatch => {
  dispatch({
    type: GET_FILTER_DETAILS_START,
    payload: { filterIds },
  });

  return Promise.all(
    filterIds.map(filterId => call(`/webapi/xm/1/event-filters/${filterId}`)),
  )
    .then(filtersDetails => {
      dispatch({
        type: GET_FILTER_DETAILS_SUCCESS,
        payload: filtersDetails,
      });
    })
    .catch(err => {
      dispatch({ type: GET_FILTER_DETAILS_FAIL, payload: { err } });
    });
};
